import * as PopoverPrimitive from "@radix-ui/react-popover";
import cx from "classnames";
import React from "react";

import { PopoverProps } from "./types";

export const Popover: React.FC<PopoverProps> = ({
  children,
  content,
  open,
  onOpenChange,
  side = "bottom",
  align = "center",
  sideOffset = 8,
  alignOffset = 0,
  className,
  contentClassName = "p-4",
  disabled,
  modal = false,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  avoidCollisions = true,
  collisionPadding = 8,
}) => {
  return (
    <PopoverPrimitive.Root modal={modal} open={open} onOpenChange={onOpenChange}>
      <PopoverPrimitive.Trigger asChild className={className} disabled={disabled}>
        {children}
      </PopoverPrimitive.Trigger>

      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align={align}
          alignOffset={alignOffset}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          avoidCollisions={avoidCollisions}
          className={cx(
            "z-50 min-w-32 rounded-lg border border-outline-grey bg-white shadow-subtle outline-hidden",
            contentClassName,
          )}
          collisionPadding={collisionPadding}
          side={side}
          sideOffset={sideOffset}
        >
          {content}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
};
